<template>
  <div>
    <div class="form-group" :class="{'-has-error': errors.email.length > 0}">
      <label for="email" class="label">E-mail</label>
      <input
        class="form-control"
        id="email"
        type="email"
        placeholder="Email"
        v-model="form.email"
        autocomplete
        required
      >
      <p class="description" v-if="errors.email.length > 0">{{ errors.email[0] }}</p>
    </div>

    <div class="form-group" :class="{'-has-error' : errors.password.length > 0}">
      <label for="password" class="label">
        Senha
      </label>
      <input
        class="form-control"
        id="password"
        type="password"
        placeholder="******************"
        autocomplete
        v-model="form.password"
        required
      >
      <p class="description" v-if="errors.password.length > 0">{{ errors.password[0] }}</p>
    </div>

    <div class="form-group" :class="{'-has-error' : errors.password_confirmation.length > 0}">
      <label for="password_confirmation" class="label">
        Confirmação de Senha
      </label>
      <input
        class="form-control"
        id="password_confirmation"
        type="password"
        placeholder="******************"
        autocomplete
        v-model="form.password_confirmation"
        required
      >
      <p class="description" v-if="errors.password_confirmation.length > 0">{{ errors.password_confirmation[0] }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserCredentials',

  props: {
    errors: Object,
    form: Object,
  },

  mounted() {
    this.$el.querySelector('input').focus();
  },
};
</script>
